import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { Tab, Tabs } from '@rossum/ui/material';
import { engineBasicSettingsPath, engineQueueSettingsPath } from '../routes';

type EngineSettingsKeys = 'basic-settings' | 'queue-settings';

type Tab = { key: EngineSettingsKeys; label: string; link: string };
export const EngineSettingsTabs = ({
  value,
  engineId,
}: {
  value: EngineSettingsKeys;
  engineId: number;
}) => {
  const intl = useIntl();

  const { push } = useHistory();

  const tabs: Tab[] = [
    {
      key: 'basic-settings',
      label: intl.formatMessage({
        id: 'features.engines.header.tabs.settings.basic',
      }),
      link: engineBasicSettingsPath(engineId),
    },
    {
      key: 'queue-settings',
      label: intl.formatMessage({
        id: 'features.engines.header.tabs.settings.queues',
      }),
      link: engineQueueSettingsPath(engineId),
    },
  ];

  return (
    <Tabs
      data-cy="extensions-tabs"
      value={value}
      onChange={(_, newValue) => {
        const link = tabs.find(tab => tab.key === newValue)?.link;
        if (link) {
          push(link);
        }
      }}
    >
      {tabs.map(tab => (
        <Tab
          key={tab.key}
          label={tab.label}
          data-cy={`engine-settings-tab-${tab.key}`}
          value={tab.key}
        />
      ))}
    </Tabs>
  );
};
